import { InternalTransferList } from 'commons/types/DTO/bank'
import { formatCurrencyCent } from 'commons/utils'
import { LicenseInfo } from 'ui/components/LicenseInfo'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

type Columns = {
  onCancel: (item: InternalTransferList) => void
}

export const columns = ({ onCancel }: Columns): TableColumn<InternalTransferList>[] => [
  {
    title: 'Transfer number',
    align: 'left',
    render: (item) => (
      <Link to="/internal-transfers/$internalTransferId" params={{ internalTransferId: item.id.toString() }}>
        {item.transferNumber}
      </Link>
    )
  },
  {
    title: 'Sender',
    align: 'left',
    render: (item) =>
      item.senderLicenseID ? (
        <LicenseInfo
          companyName={item.senderCompanyName}
          licenseName={item.senderLicenseName}
          licenseId={item.senderLicenseID}
          licenseType={item.senderLicenseType}
          companyId={item.senderCompanyID}
        />
      ) : (
        <LicenseInfo companyName={item.senderName} companyId={item.senderCompanyID} />
      )
  },
  {
    title: 'Recipient',
    align: 'left',
    render: (item) =>
      item.recipientLicenseID ? (
        <LicenseInfo
          companyName={item.recipientCompanyName}
          licenseName={item.recipientLicenseName}
          licenseId={item.recipientLicenseID}
          licenseType={item.recipientLicenseType}
          companyId={item.recipientCompanyID}
        />
      ) : (
        <LicenseInfo companyName={item.recipientName} companyId={item.recipientCompanyID} />
      )
  },
  {
    title: 'Amount',
    align: 'center',
    render: ({ amount }) => formatCurrencyCent(amount)
  },
  {
    title: 'Status',
    key: 'status',
    align: 'center'
  },
  {
    title: 'Date',
    key: 'date'
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) =>
      item.enableCancel && (
        <TableActions
          items={[
            {
              type: 'option',
              title: 'Cancel',
              onClick: () => onCancel(item)
            }
          ]}
        />
      )
  }
]
